// removed by extract-text-webpack-plugin
module.exports = {"selectColor":"qempo_Airpods_selectColor-3Ruii3j","circle":"qempo_Airpods_circle-3vtczsM","space-gray":"qempo_Airpods_space-gray-3d7YPCp","silver":"qempo_Airpods_silver-3Wdj2wK","green":"qempo_Airpods_green-3MdLVK0","sky-blue":"qempo_Airpods_sky-blue-1J12SWw","pink":"qempo_Airpods_pink-3-bf-5R","selectModel":"qempo_Airpods_selectModel-2CYpb9n","model":"qempo_Airpods_model-6lBLsS6"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/custom-products/Airpods/components/Airpods.scss
// module id = 2112
// module chunks = 0